<template>
    <div>
        <ui-modal
            ref="modal"
            :title="title"
            size="small"
            dismiss-on="close-button esc"
            class="document-picker"
            @open="isOpen = true"
            @hide="isOpen = false"
        >
                <document-management-pane
                    ref="documents"
                    v-if="isOpen"
                    :accept="AcceptedDocumentMimes"
                    :defaultType="defaultType"
                    item-class="col-sm-12"
                    no-save-button
                    hide-drag-area-on-upload
                    @selected="files => { $emit('selected', files); this.$refs.modal.close() }"
                />
        </ui-modal>
    </div>
</template>

<style>
    .document-picker .btn { margin: .25rem 0; }
    .document-picker .drop-target { margin-bottom: 0 }
</style>

<script>
    import DocumentManagementPane from "./DocumentManagementPane";
    import {DocumentTypes} from "../../classes/Api/Document";
    import {AcceptedDocumentMimes} from "../../../ts/DocumentPaneMimes";

    export default {
        props: {
            title: {
                type: String,
                default: 'Document Picker',
            },
            accept: {
                type: String,
                default: '*',
            },
            defaultType: {
                type: String,
                default: DocumentTypes.TYPE_INSTANCE_DOCUMENT,
            },
        },
        components: { DocumentManagementPane },
        data() {
            return {
                canSave: true,
                isOpen: false,
                AcceptedDocumentMimes,
            }
        },
        methods: {
            open() {
                this.$refs.modal.open()
            },
        }
    }
</script>